// TypesPrestationsContent.js
import {
  Input,
  Row,
  Col,
  Card,
  Typography,
  Space,
  Button,
  Form,
  Table as AntTable,
  Popconfirm,
  notification,
  Tabs,
  InputNumber,
} from "antd";
import { DeleteFilled, ExportOutlined, SyncOutlined, SearchOutlined } from "@ant-design/icons";
import "../Pages/CSS/DonnesBases.css";
import "../Pages/CSS/Traitement.css";
import { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import moment from "moment";
import { FournissDiversService } from "../Services/FournissDiversService";
import TabPane from "antd/es/tabs/TabPane";
const { Title } = Typography;
// Applique size="small" à tous les tableaux de cette page sans autre changement
const Table = ({ size = "small", ...props }) => <AntTable size={size} {...props} />;

const FournisseursDivers = () => {
  const initialTableData = [];
  const initialNewPrestation = {
    adr: "",
    classe: "",
    banque: "",
    clerib: "",
    code_bque: "",
    codeagence: "",
    compte: "",
    contact: "",
    cptebque: "",
    delai_credit: "",
    email: "",
    intitule: "",
    ninea: "",
    tel_contact: "",
    tel_fixe: "",
    cptegen: "",
    seuil_conso: "",
    seuil_endet: "",
    souscpte: "",
    type_compte: "",
  };

  const [tableData, setTableData] = useState(initialTableData);
  const [codeBqueError, setCodeBqueError] = useState(false);
  const [isIntituleFilled, setIsIntituleFilled] = useState(false);
  const [filteredData, setFilteredData] = useState(initialTableData); // Utilise initialTableData pour initialiser filteredData
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showCreateForm, setShowCreateForm] = useState(true);
  const [newPrestation, setNewPrestation] = useState(initialNewPrestation);

  const fournisseurDiversService = new FournissDiversService();

  useEffect(() => {
    setLoading(true);
    fournisseurDiversService
      .getAllFournissDivers() // Ajoutez les parenthèses pour appeler la fonction
      .then((data) => {
        setTableData(data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
    // eslint-disable-next-line
  }, []);

  const handleUpdate = async () => {
    try {
      if (selectedRowData) {
        await fournisseurDiversService.updateFournissDivers(selectedRowData); // Utilise updatePrestation pour mettre à jour la prestation sélectionnée
        const updatedData =
          await fournisseurDiversService.getAllFournissDivers();
        setTableData(updatedData);
        setSelectedRowData(null);
        notification.success({
          message: "Modification réussie",
          description: "La prestation a été modifié avec succès.",
        });
      }
    } catch (error) {
      notification.error({
        message: "erreur",
        description: "Erreur lors de la suppression de la prestation",
      });
    }
  };
  useEffect(() => {
    setFilteredData(tableData); // Initialisation des données filtrées avec les données complètes au chargement
  }, [tableData]);

  const createJounal = async () => {
    try {
      // Utilisation du numéro de compte sélectionné dans newPrestation.compte_rattache

      await fournisseurDiversService.addFournissDivers(newPrestation); // Utilisation de newPrestation pour ajouter la nouvelle prestation
      // Après l'ajout avec succès, rafraîchissez les données
      const updatedData = await fournisseurDiversService.getAllFournissDivers();
      setTableData(updatedData);
      notification.success({
        message: "Ajout réussie",
        description: "La prestation a été ajouté avec succès.",
      });
      setShowCreateForm(false); // Masquer le formulaire après l'ajout
    } catch (error) {
      notification.error({
        message: "erreur",
        description: "Erreur lors de la suppression de la prestation",
      });
    }
  };
  // Ensuite, dans votre fonction handleSave, appelez la fonction createJounal :
  const handleSave = () => {
    createJounal();
    // Réinitialiser l'état ou effectuer d'autres actions si nécessaire
  };

  const handleDelete = async (compte) => {
    try {
      await fournisseurDiversService.deleteFournissDivers(compte);
      // Suppression réussie, mettre à jour les données et notifier
      const updatedData = await fournisseurDiversService.getAllFournissDivers();
      setTableData(updatedData);
      setSelectedRowData(null);
      notification.success({
        message: "Suppression réussie",
        description: "La prestation a été supprimée avec succès.",
      });
    } catch (error) {
      // Gérer les erreurs côté frontend
      console.error("Erreur lors de la suppression de la prestation :", error);
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la suppression de la prestation.",
      });
    }
  };

  const handleRowClick = (record) => {
    setSelectedRowData(record); // Mettre à jour les données de la ligne sélectionnée
    setShowCreateForm(false)
  };

  const handleNew = () => {
    setSelectedRowData(null); // Réinitialiser les données sélectionnées
    setShowCreateForm(true); // Afficher le formulaire de création lors du clic sur "Nouveau"
    const lastCompte =
      tableData.length > 0 ? tableData[tableData.length - 1].compte : 0;

    // Mise à jour du formulaire pour le nouvel élément
    setNewPrestation({
      compte: (parseInt(lastCompte) + 1).toString(), // Incrément du compte
    });
  };

  const handleSearch = (value) => {
    const filtered = tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );

    setFilteredData(filtered); // Met à jour les données filtrées
  };

  const handleResetAll = async () => {
    try {
      const updatedData = await fournisseurDiversService.getAllFournissDivers(); // Récupère les nouvelles données
      setTableData(updatedData); // Met à jour le tableau avec les nouvelles données
      setSelectedRowData(null); // Réinitialise les données sélectionnées
    } catch (error) {}
  };

  const handleIntituleChange = (value) => {
    setNewPrestation({
      ...newPrestation,
      intitule: value,
    });
    setIsIntituleFilled(value.trim() !== ""); // Vérifie si le champ est rempli
  };

  const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return ""; // Retourne une chaîne vide si le numéro est vide

    // Enlève tous les caractères non numériques
    const cleanedNumber = phoneNumber.replace(/\D/g, "");

    // Applique le format attendu
    const formattedNumber = cleanedNumber
      .replace(/^(.{2})(.{3})(.{2})(.{2})/, "$1 $2 $3 $4") // Formatage
      .trim(); // Supprime les espaces au début et à la fin

    return formattedNumber;
  };

  const handleCodeBqueChange = (value) => {
    const codeBqueRegex = /^[A-Za-z]{0,2}\d{0,3}$/;

    if (codeBqueRegex.test(value)) {
      setCodeBqueError(false); // La valeur est valide
      setNewPrestation({
        ...newPrestation,
        code_bque: value,
      });
    } else {
      setCodeBqueError(true); // La valeur est invalide
    }
  };

  const handleExport = () => {
    const exportData = tableData.map((item) => ({
      Code: item.compte,
      Libellé: item.intitule,
      Address: item.adr,
      "Créer le": item.datecreation
        ? moment(item.datecreation).format("DD-MM-YYYY")
        : "", // Formate la date si elle existe
      "Créer par": item.create_by,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Prestations");

    XLSX.writeFile(workbook, "export_founisseursDivers.xlsx");
  };

  const columns = [
    {
      title: "Code",
      dataIndex: "compte",
      key: "compte",
      className: "small-cell",
      ellipsis: true,
      width: "10%",
      align: "center",
      render: (text) => (
        <strong>{text}</strong>
      ),
    },
    {
      title: "Libellé",
      dataIndex: "intitule",
      key: "intitule",
      className: "small-cell",
      ellipsis: true,
      width: "20%",
    },
    {
      title: "Adress",
      dataIndex: "adr",
      key: "adr",
      className: "small-cell",
      ellipsis: true,
      width: "35%",
    },
    {
      title: "Créer le",
      dataIndex: "datecreation",
      key: "datecreation",
      className: "small-cell",
      ellipsis: true,
      width: "10%",
      align: "center",
      render: (text) => text ? moment(text).format("DD/MM/YYYY") : "",
    },
    {
      title: "Créer par",
      dataIndex: "create_by",
      key: "create_by",
      className: "small-cell",
      render: (text) => text ? moment(text).format("DD/MM/YYYY") : "",
      ellipsis: true,
      width: "10%",
    },
    {
      title: (
        <div
          style={{
            backgroundColor: " #010f1c",
            color: "white",
            padding: "1px",
          }}
        ></div>
      ),
      key: "action",
      className: "small-cell",
      align: "center",
      // className: 'custom-action-column'
      ellipsis: true,
      width: "5%",
      render: (text, record) => (
        <Popconfirm
          title="Êtes-vous sûr de vouloir supprimer cette prestation ?"
          onConfirm={() => handleDelete(record.compte)}
          okText="Oui"
          cancelText="Non"
        >
          <Button
            danger
            style={{ border: "none", fontSize: "16px" }}
            icon={<DeleteFilled />}
          ></Button>
        </Popconfirm>
      ),
    },
  ];

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col xs={24} xl={16}>
          <Card>
            <Row gutter={[16, 16]}>
              <Col
                span={9}
                style={{
                  textAlign: "right",
                  display: "flex",
                  justifyContent: "start",
                }}
              >
                {/*  barre de recherche */}
                <Input
                  className="search-input-highlight"
                  placeholder="Rechercher..."
                  allowClear
                  prefix={<SearchOutlined style={{ color: "#8c8c8c" }} />}
                  style={{ width: 250 }}
                  onChange={(e) => handleSearch(e.target.value)}
                  onPressEnter={(e) => handleSearch(e.target.value)}
                />
              </Col>
              <Col
                span={15}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                {/* Vos boutons d'export et d'actualisation */}
                <Space>
                  <Button
                    className="buttonExport"
                    icon={<ExportOutlined />}
                    onClick={handleExport}
                  >
                    Export
                  </Button>
                  <Button  className="buttonRefresh"  onClick={handleResetAll} icon={<SyncOutlined />}>
                    Actualiser
                  </Button>
                </Space>
              </Col>
            </Row>
          </Card>

          <Table
            className="custom-header1-table compact-rows-table"
            bordered
            /* size='small' */ columns={columns}
            showSorterTooltip={false}
            dataSource={filteredData}
            onRow={(record) => ({
              onClick: () => handleRowClick(record),
            })}
            loading={loading}
           
          />
        </Col>

        <Col xs={24} xl={8}>
          {showCreateForm ? (
            <Card
              size="small"
              className="custom-card"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Title
                    level={4}
                    style={{ margin: 0, marginLeft: "15px", color: "#ffffff" }}
                  >
                    {" "}
                    Nouveau Fournisseur
                  </Title>
                </div>
              }
            >
              <Tabs defaultActiveKey="1">
                <TabPane tab="Informations Générales" key="1">
                  <Form layout="vertical" size="small">
                    <Form.Item label="Compte">
                      <Input
                        value={newPrestation.compte}
                        onChange={(e) =>
                          setNewPrestation({
                            ...newPrestation,
                            compte: e.target.value,
                          })
                        }
                      />
                    </Form.Item>
                    <Form.Item
                      label="Intitulé"
                      name="intitule"
                      rules={[
                        {
                          required: true,
                          message: "Veuillez entrer l'intitulé",
                        },
                      
                      ]}
                    >
                      <Input
                        onChange={(e) => handleIntituleChange(e.target.value)}
                      />
                    </Form.Item>
                    <Form.Item label="Address">
                      <Input
                        onChange={(e) =>
                          setNewPrestation({
                            ...newPrestation,
                            adr: e.target.value,
                          })
                        }
                      />
                    </Form.Item>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: "2rem",
                      }}
                    >
                      <Form.Item label="Ninea">
                        <Input
                          onChange={(e) =>
                            setNewPrestation({
                              ...newPrestation,
                              ninea: e.target.value,
                            })
                          }
                        />
                      </Form.Item>
                      <Form.Item label="Delai de Règlement (jr)">
                        <InputNumber
                          style={{ width: "100%" }}
                          defaultValue={15}
                          onChange={(value) =>
                            setNewPrestation({
                              ...newPrestation,
                              delai_credit: value,
                            })
                          }
                        />
                      </Form.Item>
                    </div>
                    <Form.Item label="Nom-Prénom">
                      <Input
                        onChange={(e) =>
                          setNewPrestation({
                            ...newPrestation,
                            contact: e.target.value,
                          })
                        }
                      />
                    </Form.Item>
                    <Form.Item label="Téléphone">
                      <Input.Group compact>
                        <Input
                          style={{ width: "20%" }}
                          defaultValue="+221"
                          disabled
                        />
                        <Input
                          style={{ width: "80%" }}
                          maxLength={9}
                          value={formatPhoneNumber(newPrestation.tel_contact)} // Affichage formaté
                          onChange={(e) =>
                            setNewPrestation({
                              ...newPrestation,
                              tel_contact: e.target.value.replace(/\s/g, ""), // Enlève les espaces pour le stockage
                            })
                          }
                        />
                      </Input.Group>
                    </Form.Item>
                    <Form.Item label="Email">
                      <Input
                        onChange={(e) =>
                          setNewPrestation({
                            ...newPrestation,
                            email: e.target.value,
                          })
                        }
                      />
                    </Form.Item>
                    <Form.Item label="Téléphone fixe">
                      <Input.Group compact>
                        <Input
                          style={{ width: "20%" }}
                          defaultValue="+221"
                          disabled
                        />
                        <Input
                          style={{ width: "80%" }}
                          onChange={(e) =>
                            setNewPrestation({
                              ...newPrestation,
                              tel_fixe: e.target.value,
                            })
                          }
                        />
                      </Input.Group>
                    </Form.Item>
                  </Form>
                </TabPane>
                <TabPane tab="Informations Bancaires" key="2">
                  <Form layout="vertical" size="small">
                    <Form.Item label=" Nom Banque">
                      <Input
                        onChange={(e) =>
                          setNewPrestation({
                            ...newPrestation,
                            banque: e.target.value,
                          })
                        }
                      />
                    </Form.Item>
                    <Form.Item
                      label=" Code Banque"
                      validateStatus={codeBqueError ? "error" : ""}
                      help={
                        codeBqueError
                          ? "Le code banque doit comporter 2 lettres suivies de 3 chiffres."
                          : ""
                      }
                    >
                      <Input
                        onChange={(e) => handleCodeBqueChange(e.target.value)}
                      />
                    </Form.Item>
                    <Form.Item label=" Code Guichet">
                      <Input
                        onChange={(e) =>
                          setNewPrestation({
                            ...newPrestation,
                            codeagence: e.target.value,
                          })
                        }
                      />
                    </Form.Item>
                    <Form.Item label=" Compte Bancaire">
                      <Input
                        onChange={(e) =>
                          setNewPrestation({
                            ...newPrestation,
                            cptebque: e.target.value,
                          })
                        }
                      />
                    </Form.Item>
                    <Form.Item label=" Clé RIB">
                      <Input
                        onChange={(e) =>
                          setNewPrestation({
                            ...newPrestation,
                            clerib: e.target.value,
                          })
                        }
                      />
                    </Form.Item>
                  </Form>
                </TabPane>
              </Tabs>
              <Form layout="vertical">
                <Form.Item style={{ textAlign: "right" }}>
                  <Space>
                    <Button
                      onClick={() => setShowCreateForm(false)}
                      style={{ backgroundColor: "#010f1c", color: "white" }}
                    >
                      Annuler
                    </Button>
                    <Button
                      type="primary"
                      htmlType="submit"
                      onClick={handleSave}
                      style={{
                        backgroundColor: "#010f1c",
                        color: "white",
                      }}
                      disabled={!isIntituleFilled} // Désactive le bouton si le champ n'est pas rempli
                    >
                      Enregistrer
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
            </Card>
          ) : (
            <Card
              size="small"
              className="custom-card"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Title
                    level={4}
                    style={{ margin: 0, color: "#ffffff", marginLeft: "15px" }}
                  >
                    {" "}
                    Modification Fournisseur
                  </Title>
                </div>
              }
            >
              <Tabs defaultActiveKey="1">
                <TabPane tab="Informations Générales" key="1">
                  <Form layout="vertical" size="small">
                    <Form.Item label="Compte">
                      <Input
                        value={selectedRowData ? selectedRowData.compte : ""}
                        onChange={(e) =>
                          setSelectedRowData({
                            ...selectedRowData,
                            compte: e.target.value,
                          })
                        }
                      />
                    </Form.Item>
                    <Form.Item label="Intitulé">
                      <Input
                        value={selectedRowData ? selectedRowData.intitule : ""}
                        onChange={(e) =>
                          setSelectedRowData({
                            ...selectedRowData,
                            intitule: e.target.value,
                          })
                        }
                      />
                    </Form.Item>
                    <Form.Item label="Address">
                      <Input
                        value={selectedRowData ? selectedRowData.adr : ""}
                        onChange={(e) =>
                          setSelectedRowData({
                            ...selectedRowData,
                            adr: e.target.value,
                          })
                        }
                      />
                    </Form.Item>
                    <Form.Item label="Téléphone">
                      <Input.Group compact>
                        <Input
                          style={{ width: "20%" }}
                          defaultValue="+221"
                          disabled
                        />
                        <Input
                          style={{ width: "80%" }}
                          maxLength={9}
                          value={formatPhoneNumber(
                            selectedRowData ? selectedRowData.tel_contact : ""
                          )}
                          onChange={(e) =>
                            setSelectedRowData({
                              ...selectedRowData,
                              tel_contact: e.target.value.replace(/\s/g, ""),
                            })
                          }
                        />
                      </Input.Group>
                    </Form.Item>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: "2rem",
                      }}
                    >
                      <Form.Item label="Ninea">
                        <Input
                          value={selectedRowData ? selectedRowData.ninea : ""}
                          onChange={(e) =>
                            setSelectedRowData({
                              ...selectedRowData,
                              ninea: e.target.value,
                            })
                          }
                        />
                      </Form.Item>
                      <Form.Item label="Delai de Règlement (jr)">
                        <InputNumber
                          style={{ width: "100%" }}
                          value={
                            selectedRowData ? selectedRowData.delai_credit : ""
                          }
                          onChange={(e) =>
                            setSelectedRowData({
                              ...selectedRowData,
                              delai_credit: e.target.value,
                            })
                          }
                        />
                      </Form.Item>
                    </div>
                    <Form.Item label="Nom-Prénom">
                      <Input
                        value={selectedRowData ? selectedRowData.contact : ""}
                        onChange={(e) =>
                          setSelectedRowData({
                            ...selectedRowData,
                            contact: e.target.value,
                          })
                        }
                      />
                    </Form.Item>
                    <Form.Item label="Email">
                      <Input
                        value={selectedRowData ? selectedRowData.email : ""}
                        onChange={(e) =>
                          setSelectedRowData({
                            ...selectedRowData,
                            email: e.target.value,
                          })
                        }
                      />
                    </Form.Item>
                    <Form.Item label="Téléphone fixe">
                      <Input.Group compact>
                        <Input
                          style={{ width: "20%" }}
                          defaultValue="+221"
                          disabled
                        />
                        <Input
                          style={{ width: "80%" }}
                          maxLength={9}
                          value={formatPhoneNumber(
                            selectedRowData ? selectedRowData.tel_fixe : ""
                          )}
                          onChange={(e) =>
                            setSelectedRowData({
                              ...selectedRowData,
                              tel_fixe: e.target.value.replace(/\s/g, ""),
                            })
                          }
                        />
                      </Input.Group>
                    </Form.Item>
                  </Form>
                </TabPane>
                <TabPane tab="Informations Bancaires" key="2">
                  <Form layout="vertical" size="small">
                    <Form.Item label=" Nom Banque">
                      <Input />
                    </Form.Item>
                    <Form.Item
                      label=" Code Banque"
                      validateStatus={codeBqueError ? "error" : ""}
                      help={
                        codeBqueError
                          ? "Le code banque doit comporter 2 lettres suivies de 3 chiffres."
                          : ""
                      }
                    >
                      <Input
                        onChange={(e) => handleCodeBqueChange(e.target.value)}
                      />
                    </Form.Item>
                    <Form.Item label=" Code Guichet">
                      <Input />
                    </Form.Item>
                    <Form.Item label=" Compte Bancaire">
                      <Input />
                    </Form.Item>
                    <Form.Item label=" Clé RIB">
                      <Input />
                    </Form.Item>
                  </Form>
                </TabPane>
              </Tabs>
              <Form layout="vertical">
                <Form.Item style={{ textAlign: "right" }}>
                  <Space>
                    <Button
                      type="primary"
                      onClick={handleNew}
                      style={{
                        backgroundColor: "transparent",
                        color: "#010f1c",
                        borderColor: "#010f1c",
                      }}
                    >
                      Nouveau
                    </Button>
                    <Button
                      onClick={handleUpdate}
                      style={{ backgroundColor: "#010f1c", color: "white" }}
                    >
                      Modifier
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
            </Card>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default FournisseursDivers;
